import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";

@Component({
  selector: 'brt-save-complete',
  templateUrl: './save-complete.component.html',
  styleUrls: ['./save-complete.component.scss']
})
export class SaveCompleteComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();
  @Input('code') code = "1234";

}
